
export default function breakCategoryLabel(label) {
	return label === 'Luz e Gás e Painéis Solares'
	? 'Luz e Gás e\nPainéis Solares'
	: label.replace(/ ([^ ]+)$/, '\n$1')
}